<template>
  <form-dialog ref="formDialog"
               max-width="700px"
               v-model="isActive"
               :sending="sending"
               :title="$t('inputs.password.modifica')"
               @confirm="onConfirm" @close="onClose">

    <v-flex xs12>
      <password-field :label="$t('inputs.password.attuale')" v-model="form.currentPassword" show-details browser-autocomplete="off" required/>
    </v-flex>

    <v-flex xs12 md6>
      <password-field
        :label="$t('inputs.password.nuovo')"
        v-model="form.newPassword"
        show-details
        browser-autocomplete="off"
        required
        :v-rules="[...$utils.rules.password]"/>
    </v-flex>

    <v-flex xs12 md6>
      <password-field
        :label="$t('inputs.password.reinserisci_nuovo')"
        v-model="form.newPasswordConfirm"
        show-details
        browser-autocomplete="off"
        required
        :v-rules="[(v => v === form.newPassword || $t('errori.password_diverse')),
                 ...$utils.rules.password]"/>
    </v-flex>
  </form-dialog>
</template>

<script>
import { PasswordField } from '@/components/inputs'
import FormDialog from './base/FormDialog'
import Toggleable from '@/mixins/toggleable'

export default {
    name: 'PasswordDialog',
    mixins: [Toggleable],
    components: {
        FormDialog,
        PasswordField
    },
    data: () => ({
        form: {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: ''
        },
        isPswd1Hidden: true,
        isPswd2Hidden: true,
        isPswd3Hidden: true,
        sending: false
    }),
    methods: {
        onConfirm () {
            this.sending = true
            let formData = new FormData()
            formData.append('username', localStorage.getItem("username"))
            formData.append('old_password', this.form.currentPassword)
            formData.append('password', this.form.newPassword)
            this.$api.azienda.update(formData).then(() => {
                this.sending = false
                this.isActive = false
                this.$snackbar.show(this.$t('inputs.password.modificato'), 'success')
                this.onClose()
            }).catch(e => {
                this.sending = false
                if (e.response && e.response.data && e.response.data.message === 'password_match') {
                    this.$snackbar.show(this.$t('errori.password_uguale'), 'error')
                } else {
                    this.$snackbar.show(this.$t('errori.password_attuale'), 'error')
                }
            })
        },
        onClose () {
            this.$refs.formDialog.reset()
        }
    }
}
</script>
